import { UnitPriceUI } from "./UnitPriceUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "@/hooks/useVariant/useVariant.ts";
import { ensureIsActiveVariant } from "@/utils/product/ensureIsActive.ts";
import { convertUnitOfMeasure } from "@/components/UnitPrice/utils/convertUnitOfMeasure.ts";
import { dispatchMonetateQEvent } from "@/utils/monetate/monetateQ";
import { useEffect } from "react";

export function UnitPrice({
  product,
  flags,
}: Pick<StandardProps, "product" | "configProps" | "flags">) {
  const { variant, isSelected } = useVariant(product);

  const activeVariant = isSelected ? ensureIsActiveVariant(variant) : null;
  const pricePerUnit = activeVariant?.pricePerUnit ?? null;

  const originalQuantity = pricePerUnit?.quantity ?? "";
  const originalUnitOfMeasure = pricePerUnit?.unitOfMeasure ?? "";
  const display = pricePerUnit?.display ?? "";

  const isThousandGramOrMlPrice =
    originalQuantity === "1000" &&
    (originalUnitOfMeasure === "g" || originalUnitOfMeasure === "ml");

  const simplifyUnitPriceDisplay =
    flags.simplifyUnitPriceDisplay.value === true;

  const shouldConvert = simplifyUnitPriceDisplay && isThousandGramOrMlPrice;
  const converted = shouldConvert
    ? convertUnitOfMeasure(originalQuantity, originalUnitOfMeasure)
    : null;

  const quantity = converted?.quantity ?? originalQuantity;
  const unitOfMeasure = converted?.unitOfMeasure ?? originalUnitOfMeasure;

  useEffect(() => {
    if (isThousandGramOrMlPrice) {
      dispatchMonetateQEvent("pdp:thousand:measure:unit:price");
    }
  }, [isThousandGramOrMlPrice, originalQuantity, originalUnitOfMeasure]);

  if (!isSelected || !activeVariant || !pricePerUnit) return null;

  return (
    <UnitPriceUI
      displayPrice={display}
      quantity={quantity}
      unitOfMeasure={unitOfMeasure}
    />
  );
}
